"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DBScriptsLog_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var DBScriptsLog_Factory = /** @class */ (function () {
    function DBScriptsLog_Factory() {
    }
    DBScriptsLog_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            DateRun: Date_Factory_1.Date_Factory.CreateIncoming(model.DateRun),
            ScriptFolder: model.ScriptFolder,
            ScriptName: model.ScriptName,
        };
        return result;
    };
    DBScriptsLog_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            DateRun: Date_Factory_1.Date_Factory.CreateOutgoing(model.DateRun),
            ScriptFolder: model.ScriptFolder,
            ScriptName: model.ScriptName,
        };
        return result;
    };
    return DBScriptsLog_Factory;
}());
exports.DBScriptsLog_Factory = DBScriptsLog_Factory;
